{
  "status": {
    "queued": "В очереди",
    "processing": "Выполняется",
    "completed": "Готово",
    "failed": "Ошибка",
    "cancelled": "Отменено"
  },
  "statusDetail": {
    "preparing": "Подготовка запроса",
    "sending": "Отправка в API",
    "awaiting": "Генерация",
    "downloading": "Скачивание файла",
    "saving": "Сохранение",
    "encoding": "Кодирование",
    "handling": "Обработка",
    "copying": "Копирование",
    "improving_storyboard": "Улучшение промпта кадра",
    "improving_video": "Улучшение промпта видео",
    "registering": "Регистрация",
    "registering_asset": "Регистрация ассета",
    "waiting_asset_active": "Ожидание активации ассета",
    "designing": "Дизайн голоса",
    "cloning": "Клонирование голоса",
    "importing": "Импорт голоса",
    "waiting_for_provider": "Ожидание провайдера",
    "provider_queued": "В очереди у провайдера",
    "provider_running": "Генерация",
    "fileProgress": "Файл {{current}} из {{total}}",
    "bulkProgress": "{{current}} из {{total}}"
  },
  "kind": {
    "season_structure": "Сезон",
    "episodes": "Серии",
    "scenes": "Сцены",
    "shots": "Шоты",
    "characters": "Персонажи",
    "locations": "Локации",
    "props": "Реквизит",
    "storyboard": "Сториборд",
    "shooting_board": "Раскадровка",
    "video": "Видео",
    "video_with_reference_prep": "Видео (референсы)",
    "video_with_animatic_reference_prep": "Видео (аниматик)",
    "assembly_export": "Склейка серии",
    "wizard_bootstrap": "Мастер проекта",
    "project_cover": "Обложка проекта",
    "character_reference": "Референс героя",
    "character_sheet": "Лист героя",
    "character_scale_pose": "A-pose",
    "scale_sheet_compose": "Лист размеров",
    "prop_front_view": "Вид спереди",
    "prop_scale_sheet_compose": "Лист размеров реквизита",
    "mixed_scale_sheet_compose": "Общий лист размеров",
    "character_emotion_sheet": "Лист эмоций",
    "character_portrait": "Портрет героя",
    "character_expression_sheet": "Демо эмоций героя",
    "character_gait_reference": "Демо походки героя",
    "character_action_beat": "Демо экшена героя",
    "character_voice_demo": "Голосовое демо героя",
    "seedance_avatar_registration": "Регистрация ассета Seedance",
    "seedance_asset_registration": "Регистрация ассета Seedance",
    "location_reference": "Референс локации",
    "prop_reference": "Лист референса реквизита",
    "medium_reference": "Превью медиума",
    "camera_preset_demo": "Демо камеры",
    "storyboard_correction": "Корректировка кадра",
    "sketch_edit": "Корректировка эскиза",
    "byteplus_seedance_video_correction": "Корректировка видео (Seedance)",
    "topaz_post_production": "Постобработка видео",
    "flow_video_upscale": "Улучшение видео",
    "flow_video_depth": "Карта глубины",
    "shot_timeline_render": "Рендер таймлайна",
    "shot_timeline_lipsync": "Липсинк клипа",
    "shot_timeline_tts": "Озвучка (TTS)",
    "shot_timeline_sts": "Замена голоса",
    "animatic_metadata": "Аниматик",
    "animatic_web_preview": "Web-превью аниматика",
    "animatic_segment_poster": "Постер сегмента",
    "shot_frame_capture": "Скриншот шота",
    "animatic_segment_reference_clip": "Референс-видео аниматика",
    "animatic_segment_transcription": "Расшифровка сегмента",
    "animatic_segment_shooting_board_strip": "Раскадровка из аниматика",
    "animatic_markers_split": "Нарезка аниматика по меткам",
    "animatic_bulk_segments": "Массовая обработка сегментов",
    "project_duplicate": "Дублирование проекта",
    "project_export": "Экспорт проекта",
    "bulk_improve_prompt": "Улучшение промптов",
    "agent_create_shots_batch": "Создание шотов (агент)",
    "link_cast_llm": "Расстановка героев по кадрам",
    "link_locations_llm": "Расстановка локаций по кадрам",
    "canvas_generate": "Генерация на холсте",
    "flow_bulk_regenerate": "Перегенерация нод",
    "voice_design_previews": "Дизайн голоса",
    "voice_remix_previews": "Ремикс голоса",
    "voice_ivc_create": "Клонирование голоса",
    "voice_import": "Импорт голоса",
    "file_to_skill": "Загрузка скилла",
    "billing_operations_export": "Выгрузка операций",
    "billing_usage_export": "Выгрузка журнала использования",
    "promo_codes_export": "Выгрузка промокодов",
    "promo_redemptions_export": "Выгрузка применений промокодов",
    "promo_qr_export": "QR-коды промокодов",
    "promo_cards_export": "Визитки промокодов",
    "agent_chat": "Чат с ассистентом",
    "agent_voice_prompt": "Голосовой ввод",
    "voice_dialogue_reference": "Диалоговый референс",
    "voice_tts_preview": "Проба озвучки"
  },
  "toast": {
    "completed": "Готово: {{kind}}",
    "completedWithErrors": "{{kind}}: готово {{done}} из {{total}}, ошибок {{failed}}",
    "bulkAllFailed": "{{kind}}: не удалось обработать ни одного сегмента ({{failed}})",
    "failed": "Ошибка: {{kind}}",
    "failedWithMessage": "{{kind}} — {{message}}",
    "exportReady": "Файл готов: {{label}} — нажмите «Скачать»"
  },
  "historyLoadFailed": "Не удалось загрузить историю.",
  "requestLogsLoadFailed": "Не удалось загрузить логи.",
  "noJobs": "Нет задач.",
  "active": "Активные",
  "history": "История",
  "loadMore": "Загрузить ещё",
  "downloadExport": "Скачать выгрузку",
  "stopGeneration": "Остановить генерацию",
  "stopGenerationConfirm": "Остановить эту генерацию?",
  "stopExport": "Отменить выгрузку",
  "stopExportConfirm": "Отменить эту выгрузку?",
  "showRequestPayload": "Показать payload запроса",
  "queueTitle": "Очередь генерации",
  "hideActions": "Скрыть действия",
  "startParallelGeneration": "Запустить ещё одну генерацию параллельно",
  "sketchSubjectPrefix": "Корректировка"
}
